import * as LTD from "../../def/lookup-tables.ident.gen";
import { useLookupTableList } from "../../hooks/useLookupTables";

import { Checkbox } from "@result/rui/components";
import { upperFirst } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";

const BreedingValuesMetodaIzracunaCheckbox = ({ formField }) => {
  const metodeIzracuna = useLookupTableList(LTD.SifPlemVredMetodaIzracuna);
  const { t } = useTranslation();

  return (
    <div>
      <div className="label">{t("breedingValues.calculationMethods")}</div>
      <div className="is-flex is-flex-wrap-wrap is-gap-1">
        {metodeIzracuna?.map((metoda) => (
          <Checkbox
            label={upperFirst(metoda.naziv?.sl ?? metoda.sifra)}
            onChange={(isChecked) => {
              const newMethods = [...(formField.value ?? [])];
              if (isChecked) {
                newMethods.push(metoda.sifra);
              } else {
                newMethods.splice(newMethods.indexOf(metoda.sifra), 1);
              }
              formField.setValue(newMethods);
            }}
            isChecked={(formField.value ?? []).includes(metoda.sifra)}
            key={metoda.sifra}
          />
        ))}
      </div>
    </div>
  );
};

export default BreedingValuesMetodaIzracunaCheckbox;
